import { queryParams } from '@ezugi/utils';

const { gameId } = queryParams.params;

export const isUBJonURL = gameId === 12;
export const isBJVConURL = gameId === 51;
export const isBJSPonURL = gameId === 46;
